var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWevets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 664.000000 524.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,524.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275 5214 c-98 -17 -211 -71 -244 -114 -43 -59 -40 -83 49 -385 425 -1451 1005 -3128 1355 -3920 87 -197 218 -453 283 -552 112 -169 202 -224 379 -231 178 -7 273 42 375 195 177 264 446 866 748 1673 50 135 95 248 99 253 4 4 24 -41 45 -100 275 -775 555 -1440 728 -1730 89 -147 142 -204 236 -250 76 -38 76 -38 201 -38 115 0 131 2 181 26 31 14 73 41 93 59 114 100 309 483 546 1074 275 683 658 1771 945 2681 161 512 336 1110 336 1148 0 66 -45 124 -130 166 -81 41 -167 55 -320 55 -268 -2 -463 -68 -547 -187 -15 -22 -53 -150 -118 -402 -275 -1059 -545 -1957 -810 -2695 -151 -419 -179 -491 -186 -482 -15 15 -158 410 -286 787 -268 795 -469 1483 -733 2510 -34 132 -68 252 -76 266 -32 63 -162 141 -289 174 -149 38 -335 38 -503 0 -153 -36 -238 -118 -216 -212 27 -120 185 -646 351 -1173 58 -184 109 -349 114 -366 8 -27 -1 -61 -55 -215 -183 -525 -364 -979 -614 -1542 -76 -173 -108 -234 -114 -223 -14 25 -114 304 -204 571 -234 692 -493 1554 -764 2546 -59 219 -116 413 -125 433 -32 67 -126 129 -265 174 -134 44 -310 53 -465 26z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWevets);
export default __webpack_public_path__ + "static/media/wevets.f1182cb9eabd3cb993afe8c4c5471e7a.svg";
export { ForwardRef as ReactComponent };